// extracted by mini-css-extract-plugin
module.exports = {"label":"Switch_label__3Z6mi","labelError":"Switch_labelError__2aW6g"};